<div class="preloader" [ngClass]="windowLoad ? 'd-none':''">
    <img src="assets/img/royalty-logo.jpeg" class="preloader-image" width="60" alt="preloader"/>
</div>